/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Apa_S4Inputs */

const en_mk_tut_apa_s4 = /** @type {(inputs: Mk_Tut_Apa_S4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`**Company memory** is where the house rules live: tone of voice, prices, words you must not use. Agents read it before they work.`)
};

const id_mk_tut_apa_s4 = /** @type {(inputs: Mk_Tut_Apa_S4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`**Memori perusahaan** adalah tempat aturan rumah disimpan: nada bicara, harga, kata yang tidak boleh dipakai. Agen membacanya sebelum bekerja.`)
};

/**
* | output |
* | --- |
* | "**Company memory** is where the house rules live: tone of voice, prices, words you must not use. Agents read it before they work." |
*
* @param {Mk_Tut_Apa_S4Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_apa_s4 = /** @type {((inputs?: Mk_Tut_Apa_S4Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Apa_S4Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_apa_s4(inputs)
	return en_mk_tut_apa_s4(inputs)
});